<template>
  <div>
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
    >
<!--      <div v-for="item in list" :key="item.id">-->
<!--        {{item}}-->
<!--      </div>-->

      <div style="display: flex;align-items: center;justify-content: space-around;font-size: 14px;padding: 10px;font-weight: bold;background: white">
        <div>微信用户</div>
        <div>扫码时间</div>
      </div>
      <van-cell v-for="item in list" :key="item.id">
        <div style="display: flex;align-items: center;justify-content: space-around">
          <div style="display: flex;justify-content:center; align-items: center; padding: 20px 0">
            <img :src="item.contactDetail.external_contact.avatar" style="width: 50px; height: 50px; margin-right: 10px; border-radius: 50%;"/>
            <div style="lineHeight: 25px">
              <div>
                <span style="margin-right: 5px"><strong>{{item.contactDetail.external_contact.name}}</strong></span>
              </div>
            </div>
          </div>
          <div>
          {{formatDate(item.createTime)}}
          </div>

        </div>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import Vue from 'vue';
import { List,Cell,CellGroup } from 'vant';
import {listTechSupportVisitor} from "@/api/tech_support";
import {handlePromise} from "@/libs/util";
import moment from "moment";

Vue.use(List)
    .use(Cell)
    .use(CellGroup);
export default {
  name: "tech-support-visitor-list",
  data(){
    return {
      list: [],
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10
    }
  },
  methods: {
    formatDate(date, format) {
      if (!date) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD HH:mm:ss";
      }
      return moment(date).format(format);
    },
    onLoad() {
      this.loading = true
      handlePromise(listTechSupportVisitor(this.pageNo,this.pageSize),(data)=>{
        this.loading = false
        this.list = this.list.concat(data.list)
        this.pageNo++;
        if(this.list.length === data.total){
          this.finished = true
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
